define(["require", "exports", "jquery", "knockout", "log", "../../utils/tools", "../../models/UserContext", "../../models/CPCustomerProfileModel", "../../models/CPPackageModel", "../../utils/LookupDataSources"], function (require, exports, $, ko, log, tools, UserContext, CPCustomerProfileModel, CPPackageModel, LookupDataSources) {
    "use strict";
    var CPActions = /** @class */ (function () {
        function CPActions() {
            this.userCanEditCPCustomerProfile = ko.observable(UserContext.hasAccess("Admin,CPCustomerProfiles.Edit,CPCustomerProfiles.Delete"));
            this.userCanDeleteCPCustomerProfile = ko.observable(UserContext.hasAccess("Admin,CPCustomerProfiles.Delete"));
            this.editModel = ko.observable(new CPCustomerProfileModel());
            this.editModulesModel = ko.observable(new CPPackageModel());
        }
        CPActions.prototype.editCPCustomerProfile = function (id, customerId, customerName) {
            console.log('editCPCustomerProfile', id, customerId);
            var self = this;
            var title = "Add New CP Profile";
            if (!isNaN(id)) {
                title = "Edit CP Profile";
            }
            tools.editModal({
                title: title,
                buttonTitle: "Save",
                type: "info",
                modalOptions: {},
                save: function (event, modal) {
                    self.editModel().PackageId(self.packagesDropdown.value());
                    self.editModel().PbxDomain(self.domainsDropdown.value());
                    if (!self.editModel().Name()) {
                        tools.error("CP Profile name is a required field");
                        return;
                    }
                    //validate form
                    if (!self.editModel().CustomerId()) {
                        tools.error("Customer is a required field");
                        return;
                    }
                    if (!self.editModel().PackageId()) {
                        tools.error("Package is a required field");
                        return;
                    }
                    /*if (!self.editModel().PbxDomain()) {
                        tools.error("Pbx Domain is a required field");
                        return;
                    }*/
                    if (self.editModel().Domains() && self.editModel().Domains().length > 0) {
                        if (self.editModel().Domains().filter(function (x) { return !x.Domain(); }).length > 0) {
                            tools.error("Additional domains contains empty domain record");
                            return;
                        }
                        else {
                            self.editModel().DomainList(self.editModel().Domains().map(function (x) { return x.Domain() + '|' + x.Alias(); }));
                        }
                    }
                    else {
                        self.editModel().DomainList([]);
                    }
                    $(event.currentTarget).button("loading");
                    self.saveCPCustomerProfile(event.currentTarget, modal);
                },
                opened: function (modal) {
                    var getModelCall = null;
                    if (!isNaN(id)) {
                        getModelCall = tools.ajaxGet({
                            url: "/CPCustomerProfiles/GetCPCustomerProfileById",
                            data: { id: id },
                            success: function (result) {
                                if (result.Success) {
                                    self.editModel(new CPCustomerProfileModel(result.Data));
                                }
                                else {
                                    log.error(result.Error);
                                }
                            }
                        });
                    }
                    else {
                        self.editModel(new CPCustomerProfileModel());
                        if (customerId) {
                            self.editModel().CustomerId(customerId);
                            self.editModel().Name(customerName);
                        }
                    }
                    $.when(getModelCall).done(function (data) {
                        $(modal).find(".modal-body").html("<div data-bind=\"template: { name: 'cpcustomerprofile-edit-template', data: editModel }\"></div>");
                        ko.applyBindings(self, modal);
                        var lookupDataSources = new LookupDataSources();
                        var customersDS = lookupDataSources.createLookupDataSource("Customers");
                        self.customersDropdown = $("input[name=CustomerId]", modal).kendoDropDownList({
                            dataSource: customersDS,
                            dataTextField: "Text",
                            dataValueField: "Id",
                            valuePrimitive: true,
                            filter: "contains",
                            popup: {
                                appendTo: $(".modal-body", modal)
                            },
                            change: function (e) {
                                self.editModel().Name(e.sender.dataItem().Text);
                                self.editModel().CustomerId(e.sender.dataItem().Id);
                                self.domainsDataSource.filter({ field: "CustomerId", operator: "eq", value: e.sender.dataItem().Id || -1 });
                            }
                        }).data("kendoDropDownList");
                        if (self.customersDropdown) {
                            self.customersDropdown.value(self.editModel().CustomerId());
                        }
                        var cpPackagesDS = lookupDataSources.createLookupDataSource("CPPackages");
                        self.packagesDropdown = $("input[name=PackageId]", modal).kendoDropDownList({
                            dataSource: cpPackagesDS,
                            dataTextField: "Text",
                            dataValueField: "Id",
                            valuePrimitive: true,
                            filter: "contains",
                            popup: {
                                appendTo: $(".modal-body", modal)
                            }
                        }).data("kendoDropDownList");
                        if (self.packagesDropdown) {
                            self.packagesDropdown.value(self.editModel().PackageId());
                        }
                        self.domainsDataSource = lookupDataSources.createLookupDataSource("CustomerServerDomainsStrict");
                        self.domainsDataSource.filter({ field: "CustomerId", operator: "eq", value: self.editModel().CustomerId() || -1 });
                        self.domainsDropdown = $("input[name=PbxDomain]", modal).kendoDropDownList({
                            dataSource: self.domainsDataSource,
                            dataTextField: "Text",
                            dataValueField: "Text",
                            valuePrimitive: true,
                            filter: "contains",
                            popup: {
                                appendTo: $(".modal-body", modal)
                            }
                        }).data("kendoDropDownList");
                        if (self.domainsDropdown) {
                            self.domainsDropdown.value(self.editModel().PbxDomain());
                        }
                    });
                }
            });
        };
        CPActions.prototype.saveCPCustomerProfile = function (btn, modal) {
            var self = this;
            var data = tools.modelToFormData(self.editModel());
            data["__RequestVerificationToken"] = $('#mainAntiForgeryTokenForm input[name="__RequestVerificationToken"]').val();
            data["NotesHtml"] = null;
            tools.ajaxPost({
                url: "/CPCustomerProfiles/SaveCPCustomerProfile",
                data: data
            }).done(function (result) {
                if (result.Success) {
                    tools.success("Changes updated successfully");
                    if (self.editModel().Id() > 0) {
                        if (self.afterSuccess) {
                            self.afterSuccess();
                        }
                    }
                    else {
                        window.location.href = "/CPCustomerProfiles/Details/".concat(result.Data);
                    }
                    $(modal).modal("hide");
                    return;
                }
            }).always(function () {
                $(btn).button("reset");
            });
        };
        CPActions.prototype.deleteCPCustomerProfile = function (id) {
            var self = this;
            var data = {
                id: id
            };
            data["__RequestVerificationToken"] = $('#mainAntiForgeryTokenForm input[name="__RequestVerificationToken"]').val();
            tools.ajaxPost({
                url: "/CPCustomerProfiles/DeleteCPCustomerProfileConfirmed",
                data: data
            }).done(function (result) {
                if (result.Success) {
                    tools.success("CP Profile deleted successfully");
                    if (self.afterSuccess) {
                        self.afterSuccess();
                    }
                }
            }).always(function () {
                //btn.button("reset");
            });
        };
        CPActions.prototype.deleteCPCustomerProfileConfirm = function (id, name) {
            var self = this;
            tools.confirmModal({
                title: "Delete CP Profile",
                text: "Are you sure you want to delete CP Profile " + name + "?",
                buttonTitle: "Delete",
                type: "danger",
                modalOptions: {}
            }, function (modal) {
                $(modal).modal("hide");
                self.deleteCPCustomerProfile(id);
            });
        };
        CPActions.prototype.syncCounterPath = function (id) {
            var self = this;
            tools.success("CounterPath sync started successfully");
            tools.ajaxGet({
                url: "/CPCustomerProfiles/SyncCounterPathGroup?profileId=" + id,
                success: function (data) {
                    if (data.Success) {
                        tools.alertModal({
                            title: "Sync CounterPath",
                            text: "CounterPath sync finished successfully",
                            buttonTitle: "Close",
                            type: "info",
                            modalOptions: {},
                        });
                        // tools.success("CounterPath sync finished successfully");
                        if (self.afterSuccess) {
                            self.afterSuccess();
                        }
                    }
                    else {
                        log.error(data.Error);
                        tools.alertModal({
                            title: "Sync CounterPath",
                            text: "CounterPath sync failed",
                            buttonTitle: "Close",
                            type: "info",
                            modalOptions: {},
                        });
                    }
                }
            });
        };
        CPActions.prototype.editCustomModules = function (id) {
            var self = this;
            tools.editModal({
                title: 'Manage Customer Modules',
                buttonTitle: "Save",
                type: "info",
                modalClass: "full-width",
                modalOptions: {},
                save: function (event, modal) {
                    //validate form
                    /*if (!self.editModel().Name()) {
                        tools.error("Package Name is a required field");
                        return;
                    }*/
                    $(event.currentTarget).button("loading");
                    self.savePackage(event.currentTarget, modal);
                },
                opened: function (modal) {
                    var getModelCall = null;
                    var lookupData = null;
                    getModelCall = tools.ajaxGet({
                        url: "/CPCustomerProfiles/GetCPCustomerModulesById",
                        data: { customerProfileId: id },
                        success: function (result) {
                            if (result.Success) {
                                self.editModulesModel(new CPPackageModel(result.Data));
                            }
                            else {
                                log.error(result.Error);
                            }
                        }
                    });
                    $.when(getModelCall, lookupData).done(function () {
                        $(modal).find(".modal-body").html("<div data-bind=\"template: { name: 'cpcustom-package-edit-template', data: editModulesModel }\"></div>");
                        ko.applyBindings(self, modal);
                    });
                }
            });
        };
        CPActions.prototype.savePackage = function (btn, modal) {
            var self = this;
            var data = {
                jsonModel: JSON.stringify(tools.modelToFormData(self.editModulesModel()))
            };
            data["__RequestVerificationToken"] = $('#mainAntiForgeryTokenForm input[name="__RequestVerificationToken"]').val();
            tools.ajaxPost({
                url: "/CPCustomerProfiles/SaveCPCustomPackage",
                data: data
            }).done(function (result) {
                if (result.Success) {
                    tools.success("Changes updated successfully");
                    if (self.afterSuccess) {
                        self.afterSuccess();
                    }
                    $(modal).modal("hide");
                    return;
                }
            }).always(function () {
                $(btn).button("reset");
            });
        };
        return CPActions;
    }());
    return CPActions;
});
//# sourceMappingURL=cpActions.js.map


//////////////////
// WEBPACK FOOTER
// ./build/areas/customerPortalAdmin/cpActions.js
// module id = 44
// module chunks = 2